import { motion } from "framer-motion";
import { BadgeCheck, Leaf, Ban, Droplets, Award, ShieldCheck, Sun, Truck } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

const BADGE_ICONS = [Ban, Droplets, Award, ShieldCheck, Leaf, Sun, Truck, BadgeCheck];

export default function PurityPromise() {
  const { t } = useI18n();
  const stats = t.promise.counters || [
    { n: "2,300+", l: "Happy Families" },
    { n: "100%", l: "Pure GIR Milk" },
    { n: "0", l: "Chemicals — Ever" },
    { n: "730+", l: "Days Serving" },
  ];

  return (
    <section className="dd-section relative overflow-hidden bg-gradient-to-b from-dd-green-deep to-[#0E2414] text-white" data-testid="purity-promise">
      <div className="absolute inset-0 opacity-30 dd-grain pointer-events-none" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[300px] opacity-20 pointer-events-none"
           style={{ background: "radial-gradient(ellipse, #D6A944 0%, transparent 70%)" }} />

      <div className="dd-container relative text-center">
        <div className="dd-label text-dd-gold-soft">{t.promise.eyebrow}</div>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl mt-3 dd-shimmer">{t.promise.title}</h2>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 max-w-4xl mx-auto">
          {stats.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.09 }}
              data-testid={`promise-stat-${i}`}
            >
              <div className="font-serif text-5xl md:text-6xl text-dd-gold-soft">{s.n}</div>
              <div className="dd-label text-white/70 mt-1 text-[0.65rem]">{s.l}</div>
            </motion.div>
          ))}
        </div>

        <div className="mt-14 flex flex-wrap justify-center gap-3">
          {t.promise.badges.map((b, i) => {
            const Icon = BADGE_ICONS[i] || BadgeCheck;
            return (
              <motion.div
                key={b}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                className="inline-flex items-center gap-2 bg-white/5 border border-dd-gold/30 rounded-full px-4 py-2 text-sm backdrop-blur-sm"
              >
                <Icon className="w-4 h-4 text-dd-gold-soft" strokeWidth={1.75} />
                {b}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
